module.exports = __webpack_public_path__ + "static/media/forward.d97bd078.svg";